/**
 * Register hier na portáli. Nová hra = nový priečinok `games/<hra>/` s vlastnou
 * dlaždicou a obrazovkami + riadok tu. Portál ani ostatné hry sa nemenia.
 */

import type { ComponentType } from 'react';

import { DuneTile } from './dune/PortalTile.js';
import { KarakTile } from './karak/PortalTile.js';
import { MuraTile } from './mura/PortalTile.js';
import { OuterRimTile } from './outer-rim/PortalTile.js';
import { ScytheTile } from './scythe/PortalTile.js';
import { UnmatchedTile } from './unmatched/PortalTile.js';

export interface PortalTileProps {
  /** Presun na adresu v rámci portálu (`#/unmatched`, `#/dune`…). */
  navigate: (hash: string) => void;
}

export interface GameEntry {
  id: string;
  name: string;
  /**
   * `live` = hrá sa, `wip` = rozpracovaná (dá sa hrať, niečo chýba),
   * `planned` = na polici v knižnici, engine ešte nie je.
   */
  status: 'live' | 'wip' | 'planned';
  Tile: ComponentType<PortalTileProps>;
}

export const GAMES: GameEntry[] = [
  { id: 'unmatched', name: 'Unmatched', status: 'live', Tile: UnmatchedTile },
  { id: 'dune', name: 'Dune: Board Game', status: 'live', Tile: DuneTile },
  { id: 'karak', name: 'Karak', status: 'live', Tile: KarakTile },
  { id: 'mura', name: 'Mura: Hlas z podzemia', status: 'wip', Tile: MuraTile },
  { id: 'outer-rim', name: 'Star Wars: Outer Rim', status: 'wip', Tile: OuterRimTile },
  { id: 'scythe', name: 'Scythe', status: 'planned', Tile: ScytheTile },
];
